<template>
  <div class="dialog-app-panel" :class="isShow ? 'dialog-show' : ''">
    <appPanel class="app-panel" :isExpand="isShow" @cancel="handleClosePanel"
      :title="form.tabType == 1 ? title + '集团员工信息' : title + '外来临员信息'">
      <div class="visitor-dialog-form">
        <el-form ref="form" style="margin-left: 5px" :rules="rules" :model="form" label-width="115px">
          <div style="display: flex; justify-content: space-between">
            <div style="width: 72%">
              <div class="flex-align">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                  <el-select v-model="form.sex" style="width: 100%">
                    <el-option v-for="item in sex" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item prop="facePicFileCode" label-width="0px">
              <el-upload action="common/file/batchFileload.json" class="avatar-uploader" :show-file-list="false"
                v-if="!form.facePicFileCode" :on-success="handleAvatarSuccess"
                accept="image/png, image/jpg, image/jpeg, image/bpm" name="files" ref="upload">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="imgFile" v-else>
                <img :src="imgPath(form.facePicFileCode)" class="avatar image-file" />
                <div class="delete-icon">
                  <i class="el-icon-delete" @click="onRemoveFile"></i>
                </div>
              </div>
            </el-form-item>
          </div>
          <el-col :span="24" v-if="form.tabType == 1">
            <el-form-item label="员工类型" prop="personnelMark">
              <el-select v-model="form.personnelMark" style="width: 100%">
                <el-option v-for="(item, index) in personnelMarkArr" :label="item.label" :value="item.value" :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.tabType == 1">
            <el-form-item label="部门" prop="departmentCode">
              <el-cascader v-model="form.departmentCode" :options="departmentData" placeholder="请选择所属部门"
                style="width: 100%" :show-all-levels="false" :props="cascaderProps" @change="cascaderChange">
                <template slot-scope="{ node, data }">
                  <span>{{ data.name }}</span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.tabType == 1">
            <el-form-item label="岗位" prop="position">
              <el-select v-model="form.position" style="width: 100%" placeholder="请选择部门" :disabled="!form.departmentCode">
                <el-option v-for="(item, index) in positionList" :label="item.deptName" :value="item.deptCode"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.tabType == 1">
            <el-form-item label="工号" prop="workNo">
              <el-input v-model="form.workNo" placeholder="请输入工号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel" :loading="btnLoading">{{ btnLoading ? "提交中" : "取消" }}</el-button>
        <el-button type="primary" @click="confirm" :loading="btnLoading">{{ btnLoading ? "提交中" : "保存" }}</el-button>
      </div>
    </appPanel>
  </div>
</template>
<script>
import { api } from "../api";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Bus, Dic } from "$utils";
export default {
  components: {
    appPanel,
  },
  props: {
    departmentData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      positionList: [],
      cascaderProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        expandTrigger: "hover",
      },
      btnLoading: false,
      form: {
        tabType: 1, //集团员工，2 外来员工,
        name: "",
        sex: "",
        phone: "",
        visitorTypeCode: "",
        idCard: "",
        workNo: "",
        facePicFileCode: "",
        departmentCode: "", //部门id
        position: "", //职务
        personnelCode: "",
        personnelMark: '', //人员标识
      },
      personnelMarkArr: [],
      visitorTypeList: [],
      viewerPhotos: [],
      sex: Dic.find("SENU092"),
      isShow: false,
      title: "",
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: ["blur", "change"] }],
        sex: [{ required: true, message: "请选择性别", trigger: ["blur", "change"] }],
        personnelMark: [{ required: true, message: "请选择员工类型", trigger: ["blur", "change"] }],
        position: [
          { required: true, message: "请选择岗位", trigger: ["blur", "change"] },
        ],
        departmentCode: [
          { required: true, message: "请选择部门", trigger: ["blur", "change"] },
        ],
        phone: [{ required: true, message: "请输入", trigger: ["blur", "change"] }],
        visitorTypeCode: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
    };
  },
  created() {
    this.getPersonType()
  },
  mounted() {},
  methods: {
    // 查询员工类型
    getPersonType() {
      this.$fetch(api.queryPersonType, {}).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        const TypeData = res.returnObj;
        this.personnelMarkArr = TypeData.map(item => { 
          return {
            label: item.personnelMarkName,
            value: item.personnelMark
          }
        })
        console.log(this.personnelMarkArr, '############')
      });
    },
    cascaderChange(info) {
      console.log(info);
      const params = {
        pageBean: {
          pageNo: 1,
          pageSize: 1000,
        },
        deptCode: info[info.length - 1],
        type: "2",
        cascadeFlag: "1",
      };
      this.form.position = "";
      this.$fetch(api.queryDept, params).then((response) => {
        if (response.success) {
          this.positionList = response.returnObj.list;
        } else {
          this.$message.error(response.msgContent);
        }
      });
      console.log(this.form);
    },
    onRemoveFile(file, fileList) {
      this.$confirm("确认要删除图片吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.form.facePicFileCode = "";
        this.$forceUpdate();
      });
    },
    open(data, title) {
      console.log(data);
      this.isShow = true;
      this.title = title;
      this.queryVisitorTypeList();
      this.form.tabType = data.tabType;
      if (title == "修改") {
        this.cascaderChange([data.departmentCode]);
        for (let key in this.form) {
          this.form[key] = data[key];
        }
        // this.form = { ...data };
        this.form.sex = Number(data.sex);
      }
      console.log(this.form);
    },
    queryVisitorTypeList() {
      this.$fetch("/vas/personnel/queryVisitorTypeList.json", {}).then((res) => {
        if (res.success) {
          this.visitorTypeList = res.returnObj;
        }
      });
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    handleAvatarSuccess(res, file) {
      if (res.success) {
        this.form.facePicFileCode = res.returnObj[0].fileId;
        this.$forceUpdate();
      }
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.facePicFileCode == '' || this.form.facePicFileCode == null || this.form.facePicFileCode == undefined) { 
            this.$message.warning("请上传人脸图片")
            return
          }
          const params = {
            facePicFileCode: this.form.facePicFileCode, // 图片
            idCard: this.form.idCard, // 身份证号码
            name: this.form.name, // 姓名
            phone: this.form.phone, // 手机号
            sex: this.form.sex, // 性别
            personnelCode: this.form.personnelCode,
          };
          if (this.form.tabType == 1) {
            params.position = this.form.position;
            params.personnelType = 1;
            params.workNo = this.form.workNo;
            params.departmentCode =
              typeof this.form.departmentCode == "object"
                ? this.form.departmentCode[this.form.departmentCode.length - 1]
                : this.form.departmentCode;
            params.personnelMark = this.form.personnelMark
          } else {
            params.personnelType = 2;
            params.visitorTypeCode = this.form.visitorTypeCode;
          }
          let url =
            this.title == "新增"
              ? "/vas/personnel/addPersonnel.json"
              : "/vas/personnel/updatePersonnel.json";
          this.btnLoading = true;
          this.$fetch(url, params).then((res) => {
            this.btnLoading = false;
            if (res.success) {
              this.$message({
                showClose: false,
                message: "修改成功",
                type: "success",
                duration: 2000,
              });
              this.$emit("getList", this.form.tabType);
              this.handleClosePanel();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    handleClosePanel() {
      this.isShow = false;
      this.$refs.form.resetFields();
    },
  },
};
</script>
<style lang="scss">
.imgFile {
  display: flex;
  // width: 148px;
  // height: 148px;
  position: relative;

  &:hover {
    .delete-icon {
      opacity: 1;
    }
  }

  .delete-icon {
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 140px;
    height: 140px;
    border-radius: 6px;
    opacity: 0;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.4);
    transition: all 0.2s;
    box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
  }
}

.visitor-dialog-form {
  width: 100%;
  height: 300px;
  padding: 23px 32px 0 0;

  .el-input__inner {
    width: 100%;
  }
}

.el-form-item__label {
  line-height: 32px;
  padding-left: 5px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px !important;
  text-align: center;
}

.avatar {
  width: 140px;
  height: 140px;
  display: block;
  cursor: pointer;
}

// .add-dialog {

//   .footer {
//     // height: 30px;
//     //background: rgba(59, 64, 76, 1);
//   }
// }
</style>
